import { deriveLabResultsStatus } from '@core/src/nedoShared/features/consultations/helpers/getLabResultsStatus';
import { getRequiredLabAttachments, hasUploadedAttachments, } from '@core/src/nedoShared/features/consultations/helpers/requiredAttachments';
export const checkCanUploadResults = (isClient, consultation) => {
    if (!isClient) {
        return false;
    }
    const consultationStatus = deriveLabResultsStatus(consultation);
    if (consultationStatus.status === 'uploaded') {
        return false;
    }
    const availableStatuses = ['created', 'in_progress', 'draft'];
    if (!availableStatuses.includes(consultation.status)) {
        return false;
    }
    const requiredAttachments = getRequiredLabAttachments(consultation);
    if (requiredAttachments.length === 0) {
        return false;
    }
    if (hasUploadedAttachments(consultation)) {
        return false;
    }
    if (requiredAttachments.some((ra) => ra && ra.verified !== null)) {
        return false;
    }
    return true;
};
export const checkCanFillIntake = (isProvider, consultation) => {
    if (isProvider) {
        return false;
    }
    // TODO: check if intake is not filled
    return false;
};
